import React from "react";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";

const tableColumnPaketPenjualan = (
    handleSaveRow,
    handleEditRow,
    handleCancelRow,
    handleDeleteRow,
    handleValueChange,
    handleCategoryChange,
    handleItemChange,
    dataCategory,
    dataItem,
    tab,
) => {
    return [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {rowsPerPage} = tableMeta.tableState;
                    const rowNumber = 0 * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "category",
            label: "Jenis",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const action = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return action?.saved ?
                        <p>{val?.label}</p>
                        :
                        <SimpleDDL
                            id={`select_options_category_${tableMeta.rowIndex}`}
                            containerclassname="margin-bottom-none width width-200px"
                            name="category"
                            box="search"
                            menuPosition="fixed"
                            options={dataCategory}
                            value={val}
                            onChange={(value, {name}) => handleCategoryChange(tableMeta.rowIndex, name, value)}
                        />;
                },
                sort: false,
            },
        },
        {
            name: "kode",
            label: "Kode Item",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const action = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return action?.saved ?
                        <p>{val}</p>
                        :
                        <SimpleInput
                            id="input_text_kodeKSU"
                            name="kodeKSU"
                            readOnly
                            containerclassname="margin-bottom-none width width-200px"
                            value={val}
                        />
                },
                sort: false,
            },
        },
        {
            name: "name",
            label: "Nama Item",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const action = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return action?.saved ?
                        <p>{val?.label}</p>
                        :
                        <SimpleDDL
                            id={`select_options_category_${tableMeta.rowIndex}`}
                            containerclassname="margin-bottom-none width width-200px"
                            name="name"
                            box="search"
                            menuPosition="fixed"
                            value={val}
                            options={dataItem?.[tab]?.[tableMeta.rowIndex]}
                            onChange={(value, {name}) => handleItemChange(tableMeta.rowIndex, name, value)}
                        />;
                },
                sort: false,
            },
        },
        {
            name: "satuan",
            label: "Satuan",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const action = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return action?.saved ?
                        <p>{val}</p>
                        :
                        <SimpleInput
                            id="input_text_satuan"
                            name="satuan"
                            readOnly
                            containerclassname="margin-bottom-none width width-200px"
                            value={val}
                        />
                },
                sort: false,
            },
        },
        {
            name: "jumlah",
            label: "Jumlah Item",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const action = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return action?.saved ?
                        <p>{val}</p>
                        :
                        <SimpleInput
                            id="input_text_jumlah_item"
                            name="jumlah"
                            containerclassname="margin-bottom-none width width-100px"
                            box="onlyNumber"
                            value={val}
                            onChange={({target}) =>
                                handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                },
                sort: false,
            },
        },
        {
            name: "action",
            label: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => (
                    <FlexView hAlignContent="center" style={{gap: 10}}>
                        {!val?.readOnly && (
                            <>
                                {val?.saved ? (
                                    <>
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={
                                                <i style={{fontSize: 20, color: "red"}}
                                                   className="fa fa-pencil-alt"
                                                />
                                            }
                                            onClick={() => handleEditRow(tableMeta.rowIndex)}
                                        />
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-times"/>}
                                            onClick={() => handleDeleteRow(tableMeta.rowIndex)}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-times"/>}
                                            onClick={() => handleCancelRow(tableMeta.rowIndex)}
                                        />
                                        <SimpleButton
                                            category="action_button"
                                            style={{backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "red"}}
                                                     className="fa fa-save"/>}
                                            onClick={() => handleSaveRow(tableMeta.rowIndex)}
                                        />
                                    </>
                                )}
                            </>
                        )}

                    </FlexView>
                ),
                sort: false
            },
        }
    ]
}

const getCategoryType = (type) => {
    switch (type) {
        case "ksu":
            return "KSU_TYPE"
        case "hadiah":
            return "GIFT_TYPE";
        case "barangLain":
            return "OTHER_ITEMS_TYPE";
        case "part":
            return "PART_TYPE";
        default:
            return "KSU_TYPE";
    }
}

const dummyData = [
    {
        id: 1,
        category: {label: "Matic", value: "Matic"},
        kode: "KSU001",
        name: {label: "Payung", value: "Payung"},
        satuan: "PCS",
        jumlah: 100,
        action: {
            readOnly: true,
            saved: true,
        }
    },
]

export const configPaketPenjualan = {
    tableColumns: tableColumnPaketPenjualan,
    dummyData,
    getCategoryType
}